import React from 'react';
import ContactUsIcon from '../../../common/icons/ContactUsIcon';
import { CONTACT_US_ROUTE } from '../../../../constants/Routes';

export const contactUsGroup = [
  {
    route: CONTACT_US_ROUTE,
    icon: <ContactUsIcon size="30px" />,
    title: 'Contáctanos',
    id: 'contactUsSection',
  },
];
